export enum EExerciceCondition {
	liberal = "L",
	salarie = "S",
	benevole = "B"
}